import React from "react";
import { FiHome, FiUsers, FiUserCheck, FiUserX } from "react-icons/fi";
import tw from "tailwind-styled-components";

function SummaryCards({ data }) {

    const summaryData = {
        present: data?.present || 0,
        absent: data?.absent || 0,
    };

    const summary = [

        {
            amount: summaryData.present,
            label: "Present Today",
            color: "text-black",
            icon: <FiUserCheck size={20} className="text-purple-400" />,
        },
        {
            amount: summaryData.absent,
            label: "Absent Today",
            color: "text-black",
            icon: <FiUserX size={20} className="text-red-400" />,
        },
    ];

    return (
        <Wrapper>
            <ScrollCard>
                {summary.map((item, index) => (
                    <Card key={index}>
                        <div className="h-16">
                            <Value color={item.color}>{item.amount}</Value>
                            <Label>
                                {item.label}
                            </Label>
                        </div>

                    </Card>
                ))}
            </ScrollCard>
        </Wrapper>
    );
}


const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto flex space-x-4 py-1`;
const Card = tw.div`
  min-w-[200px] p-3 rounded-md bg-white shadow-md 
  cursor-pointer hover:shadow-sm hover:shadow-primary-color

`;
const Label = tw.div`text-gray-500 text-sm break-words flex items-center w-full mt-2 justify-between`;
const Value = tw.p`
  text-xl sm:text-2xl font-bold  
  ${({ color }) => color}
`;

export default SummaryCards;